export const COUNTY_COURT_OUTREACH_REPLIES_QUERY_KEY = [
  'admin',
  'county-court-outreach-replies',
] as const;

const STORAGE_KEY = 'cp.admin.county_court_outreach.replies_last_opened_at';

export const COUNTY_COURT_OUTREACH_REPLIES_OPENED_EVENT =
  'county-court-outreach-replies-opened';

export type CountyCourtOutreachReplyForUnread = {
  received_at: string | null;
};

export function getCountyCourtOutreachRepliesLastOpenedAt(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(STORAGE_KEY);
}

export function setCountyCourtOutreachRepliesLastOpenedAt(
  at: string = new Date().toISOString(),
): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, at);
  window.dispatchEvent(
    new CustomEvent(COUNTY_COURT_OUTREACH_REPLIES_OPENED_EVENT, { detail: at }),
  );
}

export function countUnreadCountyCourtOutreachReplies(
  replies: CountyCourtOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): number {
  if (!replies.length) {
    return 0;
  }

  const openedMs = lastOpenedAt ? Date.parse(lastOpenedAt) : Number.NaN;
  const hasValidOpenedAt = lastOpenedAt !== null && !Number.isNaN(openedMs);

  return replies.filter((reply) => {
    if (!reply.received_at) {
      return false;
    }
    const receivedMs = Date.parse(reply.received_at);
    if (Number.isNaN(receivedMs)) {
      return false;
    }
    if (!hasValidOpenedAt) {
      return true;
    }
    return receivedMs > openedMs;
  }).length;
}

export function hasUnreadCountyCourtOutreachReplies(
  replies: CountyCourtOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): boolean {
  return countUnreadCountyCourtOutreachReplies(replies, lastOpenedAt) > 0;
}
